// extracted by mini-css-extract-plugin
export default {"Root":"Warning_Root__ntxuk","Warning":"Warning_Warning__HLrBD"};